/**
 * FETCH FROM API
 * @export api
 */
const api = {
  fetch: "https://www.dnd5eapi.co/api/spells",
  fetchSingle: "https://www.dnd5eapi.co/api/spells/{id}",
};

export default api;
